/**
 * @desc 系统设置:后台角色列表
 */
import {
  RoleEntity,
  OperationRoleListQuery
} from '@eastcoal/api/auth/interface'
import { apiFetch } from '@eastcoal/common/utils/fetcher/api'
import {
  RequestOptions,
  ApiConfig
} from '@eastcoal/common/utils/fetcher/interface'

export type QueryOperationRoleListParameter = OperationRoleListQuery

const method = 'GET'
const url = '/auth/operation/role/list'

export const queryOperationRoleListApi = (
  params?: QueryOperationRoleListParameter,
  config?: Partial<RequestOptions<ApiConfig>>
) => {
  return apiFetch<Array<RoleEntity>>({
    method,
    url,
    params,
    ...config
  })
}

queryOperationRoleListApi.method = method
queryOperationRoleListApi.url = url
